import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";

export const AUR = ({ factoryOptions, getterParams }) => {
    const retailFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.TOTAL_RETAIL } };
    const retailPlanRows = SIMPLE_SUM({ factoryOptions: retailFactoryOptions, getterParams });
    const unitsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.UNITS } };
    const unitsPlanRows = SIMPLE_SUM({ factoryOptions: unitsFactoryOptions, getterParams });

    if (retailPlanRows > 0 && unitsPlanRows > 0) {
        return retailPlanRows / unitsPlanRows;
    }

    return 0;
};
